import { captureClientException } from "./sentry";

type ErrorContext = Record<string, unknown>;

function serializeError(error: unknown):
	| { name?: string; message?: string; stack?: string }
	| undefined {
	if (error instanceof Error) {
		return {
			name: error.name,
			message: error.message,
			stack: error.stack,
		};
	}
	if (typeof error === "string") return { message: error };
	if (error === undefined || error === null) return undefined;
	try {
		return { message: JSON.stringify(error).slice(0, 1000) };
	} catch {
		return { message: String(error).slice(0, 1000) };
	}
}

function reportError(message: string, error?: unknown, context?: ErrorContext): void {
	const payload = JSON.stringify({
		message,
		error: serializeError(error),
		context,
		path: `${window.location.pathname}${window.location.search}${window.location.hash}`,
		userAgent: navigator.userAgent,
	});
	if (navigator.sendBeacon) {
		const blob = new Blob([payload], { type: "application/json" });
		navigator.sendBeacon("/api/client-errors", blob);
		return;
	}
	void fetch("/api/client-errors", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: payload,
		keepalive: true,
	}).catch(() => undefined);
}

export function logError(message: string, error?: unknown, context?: ErrorContext): void {
	if (import.meta.env.DEV) {
		console.error(message, error, context);
		return;
	}
	captureClientException(message, error, context);
	reportError(message, error, context);
}
